export default "__VITE_ASSET__CtIB3wx7__"